import { ActionTree } from 'vuex';
import { EImportStep } from '@/dealroom/add-page/import-progress/types/enums/import-step';
import { IProgress } from '@/dealroom/add-page/import-progress/types/progress';
import { EImportType } from '@/dealroom/add-page/import-progress/types/enums/import-type';
import {
  EImportProgressAction,
  EImportProgressMutation,
  state as defaultState,
} from '@/dealroom/add-page/import-progress/store/import-progress.constants';
import { RootState } from '@/store/store';
import { IImportProgressState } from '@/dealroom/add-page/import-progress/store/import-progress.types';
import { ProgressConstants } from '@/dealroom/add-page/import-progress/constants/progress.constants';

export const actions: ActionTree<IImportProgressState, RootState> = {
  [EImportProgressAction.InitializeImport](
    { commit },
    { name, type, index }: { name?: string; type: EImportType; index: number }
  ) {
    commit(EImportProgressMutation.SetInitialized, { name, type, index });
  },
  [EImportProgressAction.UpdateImportProgress]({ state, commit }, prop: Partial<IProgress>) {
    const progress: IProgress = { ...state.progress, ...prop };
    commit(EImportProgressMutation.SetProgress, progress);
  },
  [EImportProgressAction.CompleteTemplateImport]({ dispatch }) {
    dispatch(EImportProgressAction.Reset);
  },
  [EImportProgressAction.ImportFailed]({ dispatch, state }, error: string) {
    if (typeof state.importIndex === 'number') {
      dispatch(EImportProgressAction.UpdateImportProgress, {
        currentStep: EImportStep.Done,
        error,
      });
      setTimeout(() => {
        dispatch(EImportProgressAction.Reset);
      }, ProgressConstants.importFailedTimeout);
    } else {
      dispatch('alert/showDangerAlert', error);
    }
  },
  [EImportProgressAction.Reset]({ commit }) {
    commit(EImportProgressMutation.SetState, defaultState);
  },
};
